export const LEGAL_ENTITY_NAME = 'LICERON TECHNOLOGIES PRIVATE LIMITED';
export const LEGAL_REGISTERED_ADDRESS =
  'Block No.10, Door No.62, Hfa Apt., Keelkathirpur Kilakattur Kanchipuram Kanchipuram Tamil Nadu India 631502';
export const LEGAL_SUPPORT_EMAIL = 'sales@liceron.in';
